import { RegisterModule } from '@/typings/common'
/* eslint object-curly-newline: 0 */
import { UsersActionsState, UsersActionsGetters, UsersActionsMutations, UsersActionsActions } from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: UsersActionsState,
    getters: UsersActionsGetters,
    mutations: UsersActionsMutations,
    actions: UsersActionsActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as usersActionsStoreModule,
  mapper as usersActionsMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
